export default {
  tiny: 24,
  small: 34,
  default: 38,
  medium: 51,
  large: 60,
  xlarge: 80,
};
